import { useMutation, useQueryClient } from '@tanstack/react-query'
import { affiliationKeys, updateAffiliatePixels } from '@entities/partnership'
import type { AffiliatePixel } from '@entities/partnership'
import { createAffiliation, createAffiliationByInvite } from '@entities/partnership'

export function useAffiliateMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (productId: string) => createAffiliation(productId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: affiliationKeys.mine() })
    },
  })
}

export function useAffiliateByInviteMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (token: string) => createAffiliationByInvite(token),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: affiliationKeys.mine() })
      void queryClient.invalidateQueries({ queryKey: affiliationKeys.marketplace() })
    },
  })
}

export function useAffiliatePixelsMutation(affiliationId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (pixels: AffiliatePixel[]) => updateAffiliatePixels(affiliationId, pixels),
    onSuccess: (pixels) => {
      queryClient.setQueryData(affiliationKeys.pixels(affiliationId), pixels)
      void queryClient.invalidateQueries({ queryKey: affiliationKeys.pixels(affiliationId) })
    },
  })
}
